import React from "react";
import { wheelBasketImages } from "../../data/wheelData";

const GiantWheelModal = ({ activeCabinData }) => {
  const showCabinData = (item, ind) => {
    if (item.type === "para") {
      return (
        <div key={ind} className="mb-3 pe-3">
          <div className="wheel-modal-head">{item?.dataHeader}</div>
          <div className="wheel-modal-content-wrapper">
            {item?.content.length > 0 &&
              item?.content.map((val, i) => (
                <p className="wheel-modal-para" key={i}>
                  {val}
                </p>
              ))}
          </div>
        </div>
      );
    } else if (item.type === "list") {
      return (
        <div key={ind} className="wheel-modal-list-wrapper">
          <div className="wheel-modal-head">{item?.dataHeader}</div>
          <ol className="wheel-modal-list">
            {item?.content.map((val, i) => (
              <li key={i}>
                <strong>{val.head}</strong>: {val.body}
              </li>
            ))}
          </ol>
        </div>
      );
    } else if (item.type === "link") {
      return (
        <div key={ind} className="wheel-modal-links-wrapper pe-3">
          <div className="wheel-modal-head">{item?.dataHeader}</div>
          <div className="wheel-modal-links">
            {item?.content.map((val, i) => (
              <a
                key={i}
                href={val.body}
                target="_blank"
                rel="noopener noreferrer"
              >
                {val.head}
              </a>
            ))}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      className="modal fade wheel-modal"
      id="cabinModal"
      tabIndex="-1"
      aria-labelledby="cabinModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body" tabIndex="0">
            <div className="wheel-modal-image-wrapper">
              {Object.keys(activeCabinData).length > 0 ? (
                <img
                  src={wheelBasketImages[activeCabinData?.name]}
                  className="wheel-modal-img"
                  alt=""
                />
              ) : null}
            </div>
            <div className="wheel-modal-heading">
              <div className="modal-head" id="cabinModalLabel">
                {activeCabinData?.header}
              </div>
            </div>

            {Object.keys(activeCabinData).length > 0 &&
              activeCabinData?.data.map((item, i) => showCabinData(item, i))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiantWheelModal;
